import React from 'react';
import { Col, Row } from 'antd';
import Flexbox from 'flexbox-react';
import { injectIntl } from 'react-intl';
import messages from './messages';
import Button from '../Button/index';
import popup from '../../actions/popup';
import Wrapper from '../LandingBlockWrapper/BlockWrapper';

const Block = injectIntl(({ number, children, label,  action }) => (
	<Col xs={20} sm={16} md={12} lg={8} className='Item'>
		<Flexbox flexDirection='column' justifyContent='space-between'>
			<h3>
				{label}
			</h3>
			<Flexbox flex='1' alignItems='center' style={{ paddingTop: 15 }}>
				<span>{number}</span>
				<div>{children}</div>
			</Flexbox>
			<Button type='primary' onClick={() => popup.show(null, 'Buy')}>
				{action}
			</Button>
		</Flexbox>
	</Col>
));


export default injectIntl(({ intl: { formatMessage } }) => (
	<Wrapper className='SaleAndRent'>
		<Flexbox flexDirection='column'>
			<Row action={formatMessage(messages.popupBuy)} type='flex' justify='center' align='middle'>
				<Col md={20} lg={16}>
					<h2>
						{formatMessage(messages.title)}
					</h2>
					<p>
						{formatMessage(messages.subtitle)}
					</p>
				</Col>
			</Row>
			<Row type='flex' justify='center' align='middle'>
				<Block number={1} action={formatMessage(messages.popupBuy)} label={formatMessage(messages.labelDevice)}>
					{/*<label>*/}
						{/*{formatMessage(messages.textRent)}*/}
					{/*</label>*/}
					<h4>
						{formatMessage(messages.textPositionDevice)}
					</h4>
				</Block>
				<Block number={3} action={formatMessage(messages.popupBuy)} label={formatMessage(messages.labelSale)}>
					<label>
						{formatMessage(messages.textSale)}
					</label>
					<h4>
						{formatMessage(messages.textPositionSale)}
					</h4>
				</Block>
			</Row>
		</Flexbox>
	</Wrapper>
));


// WEBPACK FOOTER //
// ./src/components/LandingSaleAndRent/SaleAndRent.js